import { useItem } from '@/composables/item'
import personService from '@/services/api/person'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { useAlertStore } from '../system'
import { notificationService } from '@/services/api'

export const usePersonStore = defineStore('person', () => {
	const { items, show, create, getItem } = useItem(
		personService,
		'persons',
		'Person'
	)
	const status = ref<Api.Status>('initial')

	function statusSet(value: Api.Status) {
		status.value = value
	}

	function sendGreetingMail(id) {
		statusSet('loading')
		return notificationService.welcome(id).then(
			({ data }) => {
				statusSet('ready')
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}
	function sendGreetingMailToAll(data) {
		statusSet('loading')
		return notificationService.welcomeAll(data).then(
			({ data }) => {
				statusSet('ready')
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}
	function sendInvitationMail(data) {
		statusSet('loading')
		return notificationService.sendInvitation(data).then(
			({ data }) => {
				statusSet('ready')
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}
	function loadPhonenumbers(id) {
		statusSet('loading')
		return personService.phoneNumbersGet(id).then(
			({ data }) => {
				statusSet('ready')
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}
	function loadPermissions(id) {
		statusSet('loading')
		return personService.permissionsGet(id).then(
			({ data }) => {
				statusSet('ready')
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}

	return {
		getItem,
		items,
		show,
		create,
		sendGreetingMail,
		sendGreetingMailToAll,
		sendInvitationMail,
		loadPhonenumbers,
		loadPermissions,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(usePersonStore, import.meta.hot))
}
